import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnDestroy,
  signal,
} from '@angular/core';
import { PreventScrollService } from '../../../services/prevent-scroll.service';
import { CustomerService } from '../../../services/customer.service';
import { CartService } from '../../../services/cart.service';
import { RouterLinkWithLang } from '../../../directives/router-link-with-lang/router-link-with-lang.directive';
import { LangSelectorComponent } from '../../lang-selector/lang-selector.component';
import { ServiceMenuComponent } from '../../service-menu/service-menu.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginModalComponent } from '../../login-modal/login-modal.component';
import { NgxMaskPipe } from 'ngx-mask';
import { MANAGER_PHONES, PHONE_NUMBER_MASK } from '../../../constants';
import { CartModalComponent, CartModalData } from '../../cart-modal/cart-modal.component';
import { IconComponent } from "../../icon/icon.component";
import { WishlistService } from '../../../services/wishlist.service';
import { CatalogPanelComponent } from '../catalog-panel/catalog-panel.component';

@Component({
  selector: 'sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
  imports: [
    LangSelectorComponent,
    ServiceMenuComponent,
    TranslatePipe,
    RouterLink,
    RouterLinkWithLang,
    NgxMaskPipe,
    IconComponent,
    CatalogPanelComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarMenuComponent implements OnDestroy {
  private preventScrollService = inject(PreventScrollService);
  protected customerService = inject(CustomerService);
  protected cartService = inject(CartService);
  protected wishlistService = inject(WishlistService);
  private authService = inject(AuthService);
  private dialog = inject(MatDialog);

  isMenuOpened = signal(false);
  isCatalogOpened = signal(false);

  hasName = computed<boolean>(() => {
    const customer = this.customerService.customer();
    return customer
      ? !!(customer.contactInfo.firstName || customer.contactInfo.lastName)
      : false;
  });

  protected readonly PHONE_NUMBER_MASK = PHONE_NUMBER_MASK;
  protected readonly MANAGER_PHONES = MANAGER_PHONES;

  ngOnDestroy(): void {
    this.preventScrollService.isEnabled$.next(false);
  }

  openMenu(): void {
    this.isMenuOpened.set(true);
    this.preventScrollService.isEnabled$.next(true);
  }

  closeMenu(): void {
    this.isMenuOpened.set(false);
    this.isCatalogOpened.set(false);
    this.preventScrollService.isEnabled$.next(false);
  }

  showCart(): void {
    this.dialog.open<CartModalComponent, CartModalData>(
      CartModalComponent,
      { data: { sourceForAnalytics: 'sidebar_menu' } },
    );
    this.closeMenu();
  }

  showLogin(): void {
    this.dialog.open(LoginModalComponent);
    this.closeMenu();
  }

  logout(): void {
    this.authService.logout();
    this.closeMenu();
  }
}
